
import { Injectable } from '@angular/core';

import { FormGroup, Validators, FormControl } from '@angular/forms';
import { InterfaceElement } from '../../model/asd/asd-properties/asd-ie/asd-InterfaceElement';
import { InterfaceElementTypes } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { CosyCustomizedValidationService } from './cosy-customized-validation.service';
import { CosyCommunicationControllerService } from '../controller/cosy-communication-controller.service';
import { CosyHtmlElementGenerationService } from '../generator/generator-html/cosy-html-element-generation.service';
import { InterfaceElementDefaults } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-default';
import { DatePipe } from '@angular/common';
import { cloneDeep } from 'lodash-es';

@Injectable()
export class CosyFormGroupValidationService {
  constructor(private cosyCommunicationControllerService: CosyCommunicationControllerService,
              private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService,
              private datePipe: DatePipe) {}

  toFormGroup(ie:InterfaceElement) {

    let formElements = ie.InterfaceElements;
    let ieValue;
    let ieBoolValue = false;
    let group: any = {};
    let formGroup: FormGroup;
    let elementValidators = [];

    if (formElements != null) {
      if (formElements instanceof Array) {
        formElements.forEach(formElement => {          
          if(formElement.Attributes.Visible){
    
          formElement =  this.cosyHtmlElementGenerationService.updateDisplayOnLocale(formElement);
         // console.log(formElement)
         
          if (typeof formElement.CosyDataTypeID!== 'undefined' || formElement.CosyDataTypeID != null) {
            elementValidators.push(CosyCustomizedValidationService.typeValidator(formElement.CosyDataTypeID));
          }

          if (formElement.Attributes.Required && (formElement.TypeDID == InterfaceElementTypes.InputPicklist)) {
            elementValidators.push(CosyCustomizedValidationService.selectValidatorIndex0andRequierd());
          }
          else if ( formElement.TypeDID == InterfaceElementTypes.InputPicklist && this.cosyCommunicationControllerService.RTKeyShowNullable){
            elementValidators.push(CosyCustomizedValidationService.selectValidatorIndex0());
          }
          else if (formElement.Attributes.Required && (formElement.TypeDID == InterfaceElementTypes.InputText || 
                                                formElement.TypeDID == InterfaceElementTypes.InputDate ||
                                                formElement.TypeDID == InterfaceElementTypes.InputNumber) ){
            elementValidators.push(Validators.required);
          }

          if (formElement.Attributes.Mask != null && formElement.Attributes.Mask.Pattern) {
            elementValidators.push(CosyCustomizedValidationService.maskValidator(new RegExp(formElement.Attributes.Mask.Pattern, 'i')));
          }

          if (formElement.Attributes.Min != null) {
            elementValidators.push(CosyCustomizedValidationService.minValidator(formElement.Attributes.Min));
          }

          if (formElement.Attributes.Max!= null) {
            elementValidators.push(CosyCustomizedValidationService.maxValidator(formElement.Attributes.Max));
          }

          if (elementValidators.length > 0) {
            group[formElement.InterfaceElementID] = new FormControl({ value: this.formatIEValues(formElement), disabled:!formElement.Attributes.Enabled }, Validators.compose(elementValidators));
            
          } else {
            group[formElement.InterfaceElementID] = new FormControl({ value: this.formatIEValues(formElement) || '', disabled: !formElement.Attributes.Enabled });
          }
          if (formElement.Attributes.Nullable != null && formElement.Attributes.Nullable && formElement.Values.length > 0) 
            { 
              group[formElement.InterfaceElementID + '_null'] = 
              new FormControl({ value: formElement.Values[0].nil, disabled: !formElement.Attributes.Enabled });
            } 
           group = this.generateFormControlForNonFormElements(formElement, group, ie);
    
          elementValidators = [];
        //}
        }});
        formGroup = new FormGroup(group);
      } else {
        ieValue = ie.Values.length >0 ? ie.Values[0].Value : null;
        elementValidators.push(CosyCustomizedValidationService.selectValidator(ieValue));
        group[ie.InterfaceElementID] = new FormControl({ value: ieValue }, Validators.compose(elementValidators));
        formGroup = new FormGroup(group);
      }
    }
    return formGroup;
  }

  formatIEValues(ie:InterfaceElement){
    let formattedValue : any;
   
    if(ie.Values!=null && ie.Values.length>0){
    
      if(ie.TypeDID == InterfaceElementTypes.InputPicklist && ie.CustomizeOptions!= null 
          && ie.CustomizeOptions.Multiple!= null){
        
        if(ie.Values[0].Value != InterfaceElementDefaults.InputPicklistDefault){
          formattedValue = [];
          ie.DynamicMetaData.Items.forEach(item => {
            for(let v=0; v<ie.Values.length;v++){
              if(item.ID == ie.Values[v].Value){
                let itemVal = {key: item.ID, value: item.DisplayName};
                formattedValue.push(itemVal);
              }
            }
          });
        }
        else if(ie.Values[0].Value == InterfaceElementDefaults.InputPicklistDefault){
          formattedValue = null;
        }
        
      }

      else if(ie.TypeDID == InterfaceElementTypes.InputBoolean){
        if(ie.Values[0].Value == 'true'){
          formattedValue = true;
        }
        else if(ie.Values[0].Value == 'false'){
          formattedValue = false;
        }
      }
      else {
        formattedValue = ie.Values[0].Value;
      }
    }
    return formattedValue;
  }
  
  generateFormControlForNonFormElements(ie: InterfaceElement, formGroup: FormGroup, baseIE: InterfaceElement){

    let chkAllChecked: boolean = true;
    let checkedNullValue : boolean = false;
   
    if(ie.TypeDID == InterfaceElementTypes.InputPicklist && ie.CustomizeOptions!= null && ie.CustomizeOptions.Multiple == 'multiple'){
      
     if(formGroup[ie.InterfaceElementID+'_null']!= null &&  this.cosyCommunicationControllerService.RTKeyShowNullable) checkedNullValue = formGroup[ie.InterfaceElementID+'_null'].value;
    
      if(ie.Values.length == ie.DynamicMetaData.Items.length){
        for(let val of ie.Values){
          if(!val.Checked)
           {
              chkAllChecked = false;
               break;
           }
        }  
      } else {
        	 chkAllChecked = false;
      }
      formGroup[ie.InterfaceElementID+'_alle'] = new FormControl(chkAllChecked);
      if(checkedNullValue)   formGroup[ie.InterfaceElementID+'_alle'].disable();
      
      for(let dmd of ie.DynamicMetaData.Items){
        if(ie.Values.length> 0){ 
          let index = ie.Values.map(function(e){return e.Value}).indexOf(dmd.ID);
          if(index>-1){
           // formGroup[dmd.ID]=new FormControl(ie.Values[index].Checked);
           formGroup[dmd.ID]=new FormControl(true);
          }
          else {
            formGroup[dmd.ID]=new FormControl(false);
          }
        }
        else if(ie.Values.length == 0){
          formGroup[dmd.ID]=new FormControl(false);
        }

        if(checkedNullValue) formGroup[dmd.ID].disable();
      }
      
    }
    else  if(ie.TypeDID == InterfaceElementTypes.InputDate || (ie.CustomizeOptions!= null && ie.CustomizeOptions.DisplayType == 'date')){
      if(ie.Values.length> 0 && ie.Values[0].Value !== '') {
        let dateTimeStamp = ie.Values[0].Value;
        let date = new Date(dateTimeStamp);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
      
        const dateIni = year +'-' +month+'-' +day;
        const iniYear =  Number(this.datePipe.transform(dateIni, 'yyyy'));
        const iniMonth =  Number(this.datePipe.transform(dateIni, 'MM'));
        const iniDay =  Number(this.datePipe.transform(dateIni, 'dd'));
        formGroup[ie.InterfaceElementID] = new FormControl({year: iniYear ,
          month: iniMonth ,
          day: iniDay})
      }
    }
    return formGroup;
  }

}


